import { render, staticRenderFns } from "./SpecimensByColorModal.vue?vue&type=template&id=4ef8c77c"
import script from "./SpecimensByColorModal.vue?vue&type=script&lang=js"
export * from "./SpecimensByColorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports